import { useEffect, useState } from 'react';
import { FLAG_READY_TIMEOUT_MS } from './constants';

/** True once `isResolved` has stayed false for FLAG_READY_TIMEOUT_MS — the bounded, fail-closed flag wait. */
export function useFlagResolveTimeout(isResolved: boolean): boolean {
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (isResolved) return undefined;
    const timer = setTimeout(() => setExpired(true), FLAG_READY_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [isResolved]);

  return expired;
}
